import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Radio from '../atoms/Radio';
import Flex from '../atoms/Flex';
import InputLabel from '../atoms/labels/InputLabel';
const StyledRadiosItem = styled.div `
    position: relative;
    margin-bottom: 20px;

    &:first-child&:last-child {
        margin: 0;
    }
`;
const RadiosItem = ({ data, setData }) => {
    const options = [
        { id: '7', name: 'once', label: 'Eenmalig' },
        { id: '6', name: 'daily', label: 'Dagelijks' },
        { id: '5', name: 'weekly', label: 'Wekelijks' },
        { id: '4', name: 'monthly', label: 'Maandelijks' },
    ];
    return (_jsxs(StyledRadiosItem, { children: [_jsx(InputLabel, { children: "Genereer deze rapportage" }), _jsx(Flex, { margin: "0 0 20px 0", flexWrap: "wrap", children: options.map(option => {
                    return (_jsx(Radio, { name: option.name, id: option.id, label: option.label, variant: "button", checked: data.frequency.period === option.name, onChange: () => setData('frequency', {
                            ...data.frequency,
                            period: option.name,
                        }) }, option.id));
                }) })] }));
};
export default RadiosItem;
